import { render, staticRenderFns } from "./OsEntityForm.vue?vue&type=template&id=4b063ce3&scoped=true"
import script from "./OsEntityForm.vue?vue&type=script&lang=ts"
export * from "./OsEntityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b063ce3",
  null
  
)

export default component.exports